/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMultimediaContentPageTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v20H2zm2 2v16h16V4z" />
        <path d="M18 8h-3V6h3zm-8 0H6V6h4zm8 4h-3v-2h3zm0 4h-3v-2h3zM6 10h7v6H6zm2 2v2h3v-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgMultimediaContentPageTemplate as MultimediaContentPageTemplate };
